<div class="theme-container">
  <div class="back-button">
    <span class="back-icon icon-arrow-left" (click)="backToMenuClick()"></span>
    <span class="title">Mode</span>
  </div>

  <!-- <div class="mode-option" (click)="changeTheme('device')">
        Device Theme
        @if (selectedTheme() === 'device') {
        <span class="icon icon-check"></span>
        }
    </div> -->

  <div class="mode-option" (click)="changeTheme('dark')" [class.active]="selectedTheme() === 'dark'">
    Dark Mode
    @if (selectedTheme() === 'dark') {
      <span class="icon icon-check"></span>
    }
  </div>
  <div class="mode-option" (click)="changeTheme('light')" [class.active]="selectedTheme() === 'light'">
    Light Mode
    @if (selectedTheme() === 'light') {
      <span class="icon icon-check"></span>
    }
  </div>
</div>
